import { useNuxtApp, useRoute, useLocalePath, useRuntimeConfig, useInternationalization, useLocalWishlist } from '#imports'
import { useWishlist } from '@shopware/composables'

/**
 * Handles post-login actions that are common across all login methods
 * (traditional login, magic link, etc.)
 */
export function useLoginSuccess() {
    const nuxtApp = useNuxtApp()
    const route = useRoute()
    const localePath = useLocalePath()
    const { formatLink } = useInternationalization(localePath)
    const $config = useRuntimeConfig()
    const basePath = ($config?.app?.baseURL || '/') === '/' ? '' : ($config?.app?.baseURL || '')
    const { mergeWishlistProducts, canSyncWishlist } = useWishlist()
    const { clearWishlist: clearLocalWishlist } = useLocalWishlist()

    /**
     * Handles all post-login actions:
     * - Triggers login analytics hook
     * - Merges wishlist if applicable
     * - Redirects to appropriate page (target, returnUrl, or customer account)
     */
    async function handleLoginSuccess() {
        // Trigger login hook for analytics/tracking
        nuxtApp.callHook('login')

        // Merge wishlist if needed
        if (canSyncWishlist.value) {
            await (mergeWishlistProducts() as unknown as Promise<void>)
            await clearLocalWishlist()
        }

        // Determine redirect URL
        let redirectUrl = '/customer' // default

        if (route?.query?.target != null) {
            const target = String(route.query.target)
            redirectUrl = target.startsWith('/') ? target : `/${target}`
        } else if (route?.query?.returnUrl != null) {
            const returnUrl = String(route.query.returnUrl)
            redirectUrl = returnUrl.startsWith('/') ? returnUrl : `/${returnUrl}`
        }

        // Perform redirect
        window.location.href = `${basePath}${formatLink(redirectUrl)}`
    }

    return {
        handleLoginSuccess
    }
}
